import React from 'react';
import { Building2, Tractor, Home, Factory, FileText, Scale, CheckCircle, ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { services } from '../data/mock';
import SEO from '@/components/SEO';

const Services = () => {
  const iconMap = {
    Building2, Tractor, Home, Factory, FileText, Scale
  };

  const additionalServices = [
    "Certificate of Valuation for Income Tax",
    "Wealth Tax Compliance Reports",
    "Legal Matter Valuations",
    "Bank Mortgage Valuations",
    "Property Tax Assessment",
    "Stamp Duty Valuation",
    "Insurance Valuation",
    "Rental Valuation",
    "Project Financing Valuation",
    "Balance Transfer Valuation"
  ];

  return (
    <div className="bg-background pt-32 pb-20">
      <SEO
        title="Property Valuation Services — Mehta Associates"
        description="Comprehensive valuation services for residential, commercial, industrial and agricultural properties across Gujarat. Bank-approved and legally compliant."
        pathname="/services"
        keywords={["property valuation services", "bank approved valuer", "Mehta Associates"]}
      />
      <div className="container mx-auto px-4">
        {/* Header */}
        <div className="text-center mb-16">
          <h1 className="heading-1 text-foreground mb-6">VALUATION SERVICES</h1>
          <p className="body-large text-[#666666] max-w-3xl mx-auto">
            Comprehensive property valuation services for all types of real estate, agriculture land, and commercial properties across Gujarat.
          </p>
        </div>

        {/* Main Services */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-20">
          {services.map((service) => {
            const Icon = iconMap[service.icon] || ArrowRight;
            return (
              <div
                key={service.id}
                className="bg-card border border-border hover:border-primary transition-all duration-300 group overflow-hidden"
              >
                <div className="p-8">
                  <div className="w-16 h-16 bg-white border border-border rounded-lg flex items-center justify-center mb-6 group-hover:scale-105 transition-transform">
                    <Icon className="text-foreground" size={32} />
                  </div>
                  <h3 className="heading-5 text-foreground mb-4">{service.title}</h3>
                  <p className="body-small text-[#666666] mb-6">{service.description}</p>
                  <div className="flex items-center gap-2 text-foreground text-sm font-medium">
                    <span>Learn More</span>
                    <ArrowRight size={16} className="group-hover:translate-x-1 transition-transform" />
                  </div>
                </div>
                <div className="h-1 bg-primary transform scale-x-0 group-hover:scale-x-100 transition-transform origin-left"></div>
              </div>
            );
          })}
        </div>

        {/* Additional Services */}
        <div className="bg-card p-12 border border-border mb-12">
          <h2 className="heading-4 text-foreground mb-8 text-center">Additional Valuation Services</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {additionalServices.map((service, index) => (
              <div key={index} className="flex items-center gap-3">
                <CheckCircle className="text-foreground flex-shrink-0" size={20} />
                <span className="body-small text-muted">{service}</span>
              </div>
            ))}
          </div>
        </div>

        {/* Service Features */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12">
          <div className="bg-card p-8 text-center border border-border">
            <div className="text-5xl font-bold text-foreground mb-2">24 Hrs</div>
            <div className="body-medium text-muted">Fast Delivery</div>
            <p className="caption text-muted mt-2">Get your valuation report within 24 hours</p>
          </div>
          <div className="bg-card p-8 text-center border border-border">
            <div className="text-5xl font-bold text-foreground mb-2">100%</div>
            <div className="body-medium text-muted">Legal Compliance</div>
            <p className="caption text-muted mt-2">All reports follow government guidelines</p>
          </div>
          <div className="bg-card p-8 text-center border border-border">
            <div className="text-5xl font-bold text-foreground mb-2">15+</div>
            <div className="body-medium text-muted">Bank Approved</div>
            <p className="caption text-muted mt-2">Empanelled with major banks & NBFCs</p>
          </div>
        </div>

        {/* CTA Section */}
        <div className="text-center bg-card p-12 border-2 border-border">
          <h2 className="heading-4 text-foreground mb-4">Need Property Valuation?</h2>
          <p className="body-medium text-muted mb-8 max-w-2xl mx-auto">
            Get accurate, legally compliant valuation reports for any type of property. Contact us today for a free consultation.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link to="/contact" className="btn-primary">
              Request Valuation
            </Link>
            <Link to="/process" className="btn-secondary">
              View Process
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Services;
